export default "__VITE_ASSET__CbRimo_B__"